export default __webpack_public_path__ + "static/media/Exterior.8edb4612.jpg";